/**
 * @desc 禁用启用
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: any): Promise<BaseResponse<defs.ResultBean>> {
  return fetch({
    url: config.API_HOST + '/auth/user/doubleCheck',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
